import * as React from "react"
import Layout from '../components/layout';
import { Timeline, Tween } from 'react-gsap';
// import { Helmet } from "react-helmet";
import LinkCustom from '../components/TransitionLinks/LinkCustom';
import VideoModal from "../components/video-modal";
import { withPrefix } from 'gatsby'
import { Preloader, Placeholder } from 'react-preloading-screen';
import { ImpulseSpinner } from "react-spinners-kit";

// import Logo from '../images/the-talk-logo-stacked.svg'
import Logo from '../images/the-talk-continues-logo-stacked.svg'

export default class Index extends React.Component {
  constructor() {
    super();
    this.state = {
      progress: 0,
      playState: 'play',
      pauseButtonText: 'Pause',
      introButtonText: 'Skip Intro'
    };
    this.pause = this.pause.bind(this);
    this.skip = this.skip.bind(this);
    this.complete = this.complete.bind(this);
    this.videoTeaser = React.createRef();
  }

  pause() {
    if (this.state.playState == 'play') {
      this.setState({playState: 'pause'});
      this.setState({pauseButtonText: 'Play'});
      this.videoTeaser.current.pause();
    } else if (this.state.playState == 'pause') {
      this.setState({playState: 'play'});
      this.setState({pauseButtonText: 'Pause'});
      this.videoTeaser.current.play();
    }
  }

  skip() {
    if (this.state.progress < 1) {
      this.setState({progress: 1});
      this.setState({introButtonText: 'Replay Intro'});
    } else {
      this.setState({progress: 0});
      this.setState({introButtonText: 'Skip Intro'});
    }
  }

  complete() {
    this.setState({progress: 1});
    this.setState({introButtonText: 'Replay Intro'});
  }

  render() {
    return (
      <Layout LocationInfo={this.props.location}>
      <section className="page-content-wrapper index">

      <Preloader style={{backgroundColor: '#000'}}>
          

      <Timeline
        progress={this.state.progress}
        playState={this.state.playState}
        onComplete={this.complete}
        target={
          <div className="intro-text">
            <p><span className="highlight">“The Talk: A Journey Toward Anti-Racism”</span> is a video series that invites campus and community members to talk about their journeys. The series debuted after the summer of 2020 protests and calls for action.</p>
          </div>
        }
      >
        <Tween from={{ opacity: 0, y: '20px' }} to={{ opacity: 1, y: '0px' }} duration={3} />
        <Tween to={{ opacity: 1 }} duration={5} />
        <Tween to={{ opacity: 0 }} duration={1} />

          <Timeline
            target={
              <div className="intro-text">
                <p>This series expands further with <span className="highlight">“The Talk Continues.”</span></p>
              </div>
            }
          >
            <Tween from={{ opacity: 0, y: '20px' }} to={{ opacity: 1, y: '0px' }} duration={3} />
            <Tween to={{ opacity: 1 }} duration={5} />
            <Tween to={{ opacity: 0 }} duration={1} />

            <Timeline
              target={
                <div className="intro-text">
                  <p>In this edition, a new group of Titans tells their story through the lens of their <span className="highlight">multiple identities</span>, explaining how they intersect and how that intersection informs their journey towards anti-racism.</p>
                </div>
              }
            >
              <Tween from={{ opacity: 0, y: '20px' }} to={{ opacity: 1, y: '0px' }} duration={3} />
              <Tween to={{ opacity: 1 }} duration={5} />
              <Tween to={{ opacity: 0 }} duration={1} />

              <Timeline
                target={
                  <div className="intro-text">
                    <p>The series stems from <span className="highlight">"The Talk,"</span> a conversation about race and anti-Blackness that adults in the Black community must have with their loved ones from an early age.</p>
                  </div>
                }
              >
                <Tween from={{ opacity: 0, y: '20px' }} to={{ opacity: 1, y: '0px' }} duration={3} />
                <Tween to={{ opacity: 1 }} duration={5} />
                <Tween to={{ opacity: 0 }} duration={1} />

                <Timeline
                  target={
                    <div className="intro-text">
                      <p>We hope these talks can be a <span className="highlight">catalyst for change</span> as Titans strive to foster a community of anti-racism at Cal State Fullerton and wherever Titans call home.</p>
                    </div>
                  }
                >
                  <Tween from={{ opacity: 0, y: '20px' }} to={{ opacity: 1, y: '0px' }} duration={3} />
                  <Tween to={{ opacity: 1 }} duration={5} />
                  <Tween to={{ opacity: 0 }} duration={1} />
                  
                    <Timeline
                      target={
                        <div className="intro-text" id="logo-panel">
                          <h1><img src={Logo} alt="The Talk Continues" /></h1>
                          <LinkCustom effect="fade" length={3} url="/continues" className="begin-button" title="Vist “The Talk Continues” to start">
                            Continue the Journey
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512" className="icon" role="img" aria-labelledby="right-arrow-title">
                              <title id="right-arrow-title">Right Arrow</title>
                              <path role="presentation" d="M0 384.662V127.338c0-17.818 21.543-26.741 34.142-14.142l128.662 128.662c7.81 7.81 7.81 20.474 0 28.284L34.142 398.804C21.543 411.404 0 402.48 0 384.662z"/>
                            </svg>
                          </LinkCustom>
                        </div>
                      }
                    >
                      <Tween from={{ opacity: 0, y: '20px' }} to={{ opacity: 1, y: '0px' }} duration={3} />
                    </Timeline>

                </Timeline>

              </Timeline>

            </Timeline>

          </Timeline>

      </Timeline>

      <VideoModal vimeoID="705560754" title="Watch the Trailer for “The Talk Continues”" />

      <div className="animation-controls">
        <button onClick={this.pause} title="">{this.state.pauseButtonText}</button>
        <button onClick={this.skip} title="">{this.state.introButtonText}</button>
      </div>

      <video id="heroVideo" autoPlay="autoplay" loop muted playsInline ref={this.videoTeaser}>
        <source src="https://news.fullerton.edu/feature/the-talk/video/loop-continues.webm" type="video/webm; codecs=vp9,vorbis" />
        <source src="https://news.fullerton.edu/feature/the-talk/video/loop-continues.mp4" type="video/mp4" />
        <track kind="captions" srcLang="en" label="English"  src={withPrefix('/video/loop-continues.vtt')} />
      </video>

        <Placeholder>
          <div style={{textAlign: 'center'}}>
            <ImpulseSpinner frontColor="#FF0000" backColor="#726060" style={{margin: '0 auto'}} />
            <span style={{display: 'block', marginTop: '10px'}}>Loading...</span>
          </div>
        </Placeholder>
      </Preloader>


      </section>
    </Layout>
    );
  }
}